import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { UrlHelpers } from '../../service/UrlHelpers';
import { LinkTarget } from '../../typings/common';
import { WelcomeBannerParams, WelcomeBannerType } from '../../typings/welcome';
import { Image2, ImageSrcSet } from '../Image2/Image2';

import './FirstCampaignTizer.css';
import * as keyset from './FirstCampaignTizer.i18n';

const i18n = i18nFactory(keyset);

export interface FirstCampaignTizerProps {
    heading: string;
    subheading?: string;
    items: WelcomeBannerParams;
    onWelcomeBannerShow: (type: WelcomeBannerType) => void;
    onWelcomeBannerClick: (type: WelcomeBannerType) => void;
}

interface ItemInfo {
    srcSet: ImageSrcSet;
    link: string;
    title: string;
}

const BANNERS: Record<WelcomeBannerType, ItemInfo> = {
    [WelcomeBannerType.AGENCY]: {
        srcSet: {
            src: require('./assets/promo_help_pic_agency@1x.png'),
            src2x: require('./assets/promo_help_pic_agency@2x.png'),
            src3x: require('./assets/promo_help_pic_agency@3x.png')
        },
        link: 'https://yandex.ru/adv/contact/agency?from=teaser',
        title: i18n('title-agency')
    },
    [WelcomeBannerType.FREELANCER]: {
        srcSet: {
            src: require('./assets/promo_help_pic_freelancer@1x.png'),
            src2x: require('./assets/promo_help_pic_freelancer@2x.png'),
            src3x: require('./assets/promo_help_pic_freelancer@3x.png')
        },
        link: UrlHelpers.getFreelancersListUrl(),
        title: i18n('title-freelancer')
    },
    [WelcomeBannerType.YANDEX]: {
        srcSet: {
            src: require('./assets/promo_help_pic_specialist@1x.png'),
            src2x: require('./assets/promo_help_pic_specialist@1x.png'),
            src3x: require('./assets/promo_help_pic_specialist@1x.png')
        },
        link: 'https://yandex.ru/promo/direct/freeservice?from=teaser',
        title: i18n('title-yandex')
    }
};

export class FirstCampaignTizer extends React.Component<
    FirstCampaignTizerProps
> {
    componentDidMount() {
        const {
            items: { suggestExternalService, suggestYandexService },
            onWelcomeBannerShow
        } = this.props;

        if (suggestExternalService) {
            onWelcomeBannerShow(WelcomeBannerType.AGENCY);
            onWelcomeBannerShow(WelcomeBannerType.FREELANCER);
        }

        if (suggestYandexService) {
            onWelcomeBannerShow(WelcomeBannerType.YANDEX);
        }
    }

    render() {
        const { heading, subheading, items } = this.props;

        return (
            <div className={Bem.cls('first-campaign-tizer')}>
                <h2 className={Bem.cls('first-campaign-tizer', 'heading')}>
                    {heading}
                </h2>

                {subheading && (
                    <div
                        className={Bem.cls(
                            'first-campaign-tizer',
                            'subheading'
                        )}
                    >
                        {subheading}
                    </div>
                )}

                <div className={Bem.cls('first-campaign-tizer', 'items')}>
                    {items.suggestYandexService &&
                        this.renderItem(WelcomeBannerType.YANDEX)}
                    {items.suggestExternalService &&
                        this.renderItem(WelcomeBannerType.FREELANCER)}
                    {items.suggestAgencyService &&
                        this.renderItem(WelcomeBannerType.AGENCY)}
                </div>
            </div>
        );
    }

    private renderItem(type: WelcomeBannerType): React.ReactNode {
        const { onWelcomeBannerClick } = this.props;
        const banner = BANNERS[type];

        return (
            <a
                href={banner.link}
                className={Bem.cls('first-campaign-tizer', 'link')}
                onClick={() => onWelcomeBannerClick(type)}
                target={LinkTarget.blank}
            >
                <Image2
                    cls={Bem.cls('first-campaign-tizer', 'item-pic')}
                    src={banner.srcSet}
                    width={40}
                    height={40}
                />
                <div className={Bem.cls('first-campaign-tizer', 'item-text')}>
                    {banner.title}
                </div>
            </a>
        );
    }
}
